import React, { Fragment } from "react";
import Footer from "../../footer";
import { Prompt, Redirect } from "react-router-dom";
import Question from "./Question.jsx";
import { connect } from "react-redux";
import { Howl } from "howler";
import Ball from "../../../assets/Ball.svg";
import SweetAlert from "react-bootstrap-sweetalert";
import axiosInstance from "../../../store/services/AxiosService";
import { deleteCaseActive, loadCaseSuccess, submitAnswer, saveAnswer, getStudentAnsweredCase } from "../../../store/actions/index";
import { withRouter } from "react-router-dom";

var that;
// var playAudio = function () {
//     var sound = new Howl({
//         src: ["https://soundbible.com/mp3/Air%20Horn-SoundBible.com-964603082.mp3"],
//         volume: 1,
//     });

//     setTimeout(() => {
//         sound.play();
//     }, 1000);
// };

// OLD
// window.onBlurHandler = function (e) {
//     let counterNotFocus = Number(localStorage.getItem("counterNotFocus"));
//     if (!counterNotFocus) {
//         counterNotFocus = 1;
//         localStorage.setItem("counterNotFocus", counterNotFocus);
//     } else if (counterNotFocus === 2 && !that.state.isLocked) {
//         that.setState({
//             isFocus: false,
//         });
//     } else if (counterNotFocus < 3) {
//         counterNotFocus += 1;
//         localStorage.setItem("counterNotFocus", counterNotFocus);
//     }

//     // if (that.state.isFocus && !that.state.isLocked) {
// 	// 	that.setState({isFocus: false})
// 	// }
// };

// window.onFocusHandler = function (e) {
//     console.log("has focus")
// 	if (!that.state.isFocus) {
// 		that.setState({isFocus: true})
// 	}
// };

class FormQuestion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            alertSave: null,
            taskDone: false,
            alertSubmit: null,
            submitCases: false,
            countDown: 5,
            initCountDown: 5,
            isFocus: true,
            isLocked: false,
            countNotFocus: 0,
            questions: [],
            isMinimized: false,
            showPassword: false,
            passwordValue: '',
            countNotFocus: 0, // NEW: Track in state
            showFocusWarning: false, // NEW: Show warning before locking
            lastBlurTime: null, // NEW: Track timing between blur events
            activeQuestionIndex: 0,
            flatQuestions: [],
        };

        // Auto-save
        this.autoSaveInterval = null;
        this.autoSaveInProgress = false;
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);

        // NEW
        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    playAudio = function () {
        var sound = new Howl({
            src: ["https://soundbible.com/mp3/Air%20Horn-SoundBible.com-964603082.mp3"],
            volume: 1,
        });

        setTimeout(() => {
            sound.play();
        }, 1000);
    };

    // NEW: Better blur detection with timing and warning
    handleBlur(e) {
        if (this.state.isLocked || this.state.submitCases) {
            return;
        }

        const currentTime = Date.now();
        const lastBlur = this.state.lastBlurTime;

        if (lastBlur && currentTime - lastBlur < 1000) {
            return;
        }

        const newCount = this.state.countNotFocus + 1;

        this.setState({
            lastBlurTime: currentTime,
            countNotFocus: newCount,
        });

        if (newCount === 2) {
            this.setState({
                showFocusWarning: true,
            });

            setTimeout(() => {
                this.setState({ showFocusWarning: false });
            }, 5000);
        }

        if (newCount >= 3) {
            this.lockExamAccess();
        }

        localStorage.setItem("counterNotFocus", newCount.toString());
        this.logFocusViolation(newCount);
    }


    // NEW: Better focus detection
    handleFocus(e) {
        if (!this.state.isFocus && !this.state.isLocked) {
            this.setState({ isFocus: true });
        }
    }

    // NEW: Additional detection using Page Visibility API
    handleVisibilityChange() {
        if (document.hidden) {
            this.handleBlur();
        } else {
            this.handleFocus();
        }
    }

    // NEW: Separate method to lock exam access
    lockExamAccess = () => {
        this.setState({ isFocus: false });

        axiosInstance
            .post("/access/set", {
                case_id: this.props.currentCase.case_id,
                api_student_id: this.props.idStudent,
                student_name: this.props.studentName,
                schedule_id: this.props.caseStudent.schedules.id,
                is_generate: true,
                school_id: this.props.currentCase.school_id,
                is_locked: true,
            })
            .then((r) => {
                this.setState({ isLocked: true });
                this.playAudio();
            })
            .catch((error) => {
                console.error(`ERROR from Server => ${error.message}`);
            });
    };

    // NEW: Log violations to server for monitoring
    logFocusViolation = (violationCount) => {
        axiosInstance
            .post("/access/log-violation", {
                case_id: this.props.currentCase.case_id,
                api_student_id: this.props.idStudent,
                student_name: this.props.studentName,
                schedule_id: this.props.caseStudent.schedules.id,
                violation_count: violationCount,
                timestamp: new Date().toISOString(),
            })
            .catch((error) => {
                console.error(`Failed to log violation => ${error.message}`);
            });
    };


    fetchDataCase = async () => {
        let res = await axiosInstance.get(`/cases/${this.props.currentCase.case_id}?schedule_id=${this.props.currentCase.schedule_id}&type_user=student&student_id=${this.props.idStudent}`);
        this.props.loadCaseSuccess(res.data);
        localStorage.setItem("dataSoal", JSON.stringify(res.data));
    };

    // AUTO-SAVE: Silently save answers to server every 60 seconds
    autoSaveToServer = () => {
        if (this.autoSaveInProgress || this.state.submitCases || this.state.isLocked) return;
        if (!this.props.caseStudent || !this.props.caseStudent.case_parts) return;

        this.autoSaveInProgress = true;
        const url = `/student_answers/create/student/${this.props.idStudent}?save=true`;
        const dataToPost = { studentAnswer: this.props.caseStudent };

        axiosInstance
            .post(url, dataToPost)
            .then(() => {
                console.log('[Auto-Save] Jawaban berhasil disimpan otomatis');
                this.autoSaveInProgress = false;
            })
            .catch((error) => {
                console.warn('[Auto-Save] Gagal menyimpan otomatis:', error.message);
                this.autoSaveInProgress = false;
            });
    };

    // AUTO-SAVE: Emergency save before tab/browser closes
    handleBeforeUnload(e) {
        if (this.state.submitCases) return;
        if (!this.props.caseStudent || !this.props.caseStudent.case_parts) return;

        const url = `/student_answers/create/student/${this.props.idStudent}?save=true`;
        const dataToPost = JSON.stringify({ studentAnswer: this.props.caseStudent });

        // Use sendBeacon for reliable delivery even when page is closing
        const baseURL = axiosInstance.defaults.baseURL || '';
        const fullUrl = baseURL + url;
        const blob = new Blob([dataToPost], { type: 'application/json' });
        navigator.sendBeacon(fullUrl, blob);
    }

    async componentDidMount() {
        const fromLocalStorage = JSON.parse(localStorage.getItem("reduxState")) || {};
        const soalFromLocalStorage = JSON.parse(localStorage.getItem("dataSoal")) || {};
        if (fromLocalStorage.User.caseStudent.case_parts === undefined) {
            await this.fetchDataCase();
        } else if (soalFromLocalStorage === undefined) {
            await this.fetchDataCase();
        }

        if (window.MathJax) {
            try {
                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, document.getElementsByTagName("body")]);
            } catch (e) {
                window.MathJax.typesetPromise();
            }
        }

        that = this;
        this.getAccess();

        // OLD
        // window.addEventListener("blur", window.onBlurHandler);
        // window.addEventListener("focus", window.onFocusHandler);

        // NEW event listeners with:
        window.addEventListener("blur", this.handleBlur);
        window.addEventListener("focus", this.handleFocus);

        // AUTO-SAVE: Start periodic auto-save every 60 seconds
        this.autoSaveInterval = setInterval(() => {
            this.autoSaveToServer();
        }, 60000);
        window.addEventListener("beforeunload", this.handleBeforeUnload);
        document.addEventListener("visibilitychange", this.handleVisibilityChange); // NEW

        // NEW: Restore focus violation count and optimistic lock from localStorage
        const savedCount = parseInt(localStorage.getItem("counterNotFocus")) || 0;
        this.setState({
            countNotFocus: savedCount,
            isLocked: savedCount >= 3 ? true : this.state.isLocked
        });

        let counter = 1; // Initialize the counter to start from 1
        const transformedData = this.props.caseStudent.case_parts.flatMap((caseItem) =>
            caseItem.case_questions.map((question) => {
                const answered = question.case_choices.some((choice) => choice.selected);
                return { id: counter++, answered };
            })
        );

        let flatQ = [];
        let qIndex = 0;

        if (this.props.caseStudent && this.props.caseStudent.case_parts) {
            Object.values(this.props.caseStudent.case_parts).forEach((part, partIndex) => {
                Object.values(part.case_questions).forEach((question) => {
                    flatQ.push({
                        ...question,
                        partName: part.name,        // Simpan nama bagian
                        typeSoal: part.type_name,   // Simpan tipe soal
                        partIndex: partIndex,
                        realIndex: qIndex           // Index global
                    });
                    qIndex++;
                });
            });
        }

        this.setState({
            questions: transformedData,
            flatQuestions: this.mappingFlatQuestions(this.props),
        });
    }

    handleSave(e, status) {
        e.preventDefault();
        const getAlert = () => (
            <SweetAlert
                custom
                showCancel
                showCloseButton
                confirmBtnText="Ya"
                cancelBtnText="Tidak"
                confirmBtnBsStyle="primary"
                cancelBtnBsStyle="light"
                title="Simpan Sementara Jawaban Kamu?"
                // saveTemperorary in reduce caseStudent change = true
                onConfirm={() => this.saveExam(this.props.idStudent)}
                onCancel={() => this.setState({ alertSave: null })}
            >
                Klik 'Ya' untuk menyimpan jawaban kamu
            </SweetAlert>
        );
        const alertTimesUp = () => (
            <SweetAlert warning title="Kamu Tidak Dapat Simpan Sementara" onConfirm={() => this.setState({ alertSave: null })} onCancel={() => this.setState({ alertSave: null })}>
                Serahkan Jawaban Untuk Menyimpan Jawaban Kamu !
            </SweetAlert>
        );

        if (status === true) {
            this.setState({
                alertSave: getAlert(),
            });
        } else {
            this.setState({
                alertSave: alertTimesUp(),
            });
        }
    }

    handleDeleteImage(fileToDelete) {
        const url = "/files/delete";
        if (fileToDelete.length === 0) {
            fileToDelete.push("");
        }
        const dataToDel = { file_name: fileToDelete };
        axiosInstance
            .post(url, dataToDel)
            .then((r) => { })
            .catch((error) => {
                alert(`Proses delete gagal => ${error.message}`);
            });
    }

    deleteImageToSave(arrContent, arrAllFile) {
        let arrLama = [];
        if (arrAllFile !== null) {
            arrLama = arrAllFile;
        }
        arrContent.map((item) => {
            return (arrLama = arrLama.filter((i) => i !== item));
        });
        this.handleDeleteImage(arrLama);
    }

    saveExam(id_student) {
        this.setState({ alertSave: null });
        let arrImgContent = [];
        Object.values(this.props.caseStudent.case_parts).map((part) => {
            Object.values(part.case_questions).map((question) => {
                if (question.answer.file_attached !== null) {
                    arrImgContent.push(question.answer.file_attached);
                }
                return arrImgContent;
            });
            return arrImgContent;
        });
        this.deleteImageToSave(arrImgContent, this.props.listImgAll);
        const url = `/student_answers/create/student/${id_student}?save=true`;
        const dataToPost = { studentAnswer: this.props.caseStudent };
        axiosInstance
            .post(url, dataToPost)
            .then(() => {
                // saveTemperorary in reduce caseStudent change = true
                this.props.saveAnswer();
                this.handleSuccessSave();
            })
            .catch((error) => {
                this.handleFailureSave(error);
            });
    }

    handleSuccessSave() {
        const alertSuccess = () => (
            <SweetAlert success title="Berhasil !" onConfirm={() => this.refreshAfterSave()}>
                Jawabanmu berhasil disimpan !
            </SweetAlert>
        );
        this.setState({
            alertSave: alertSuccess(),
        });
    }

    refreshAfterSave() {
        this.setState({
            alertSave: null,
        });
        window.location.reload(false);
    }

    handleFailureSave(errorMessage) {
        const alertFailure = () => (
            <SweetAlert warning title="Proses Gagal!" onConfirm={() => this.setState({ alertSave: null })} onCancel={() => this.setState({ alertSave: null })}>
                {errorMessage}
            </SweetAlert>
        );
        this.setState({
            alertSave: alertFailure(),
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({
            alertSubmit: "submit",
            countDown: this.state.initCountDown,
        });
    }

    submitExam(id_student) {
        this.setState({ alertSave: null, alertSubmit: null });
        let arrImgContent = [];
        Object.values(this.props.caseStudent.case_parts).map((part) => {
            Object.values(part.case_questions).map((question) => {
                if (question.answer.file_attached !== null) {
                    arrImgContent.push(question.answer.file_attached);
                }
                return arrImgContent;
            });
            return arrImgContent;
        });
        this.deleteImageToSave(arrImgContent, this.props.listImgAll);
        const url = `/student_answers/create/student/${id_student}`;
        const dataToPost = { studentAnswer: this.props.caseStudent };
        axiosInstance
            .post(url, dataToPost)
            .then((response) => {
                // AUTO-SAVE: Stop auto-save after successful submit
                if (this.autoSaveInterval) {
                    clearInterval(this.autoSaveInterval);
                    this.autoSaveInterval = null;
                }
                this.props.submitAnswer();
                this.handleSuccessSubmit();
                this.setState({ submitCases: true });
            })
            .catch((error) => {
                this.handleFailureSubmit(error);
            });
    }

    handleSuccessSubmit() {
        const alertSuccess = () => (
            <SweetAlert
                success
                title="Berhasil !"
                onConfirm={() =>
                    this.setState({
                        taskDone: true,
                    })
                }
            >
                Jawabanmu berhasil disimpan !
            </SweetAlert>
        );
        this.setState({
            alertSubmit: alertSuccess(),
        });
    }

    handleFailureSubmit(errorMessage) {
        const alertFailure = () => (
            <SweetAlert warning title="Proses Gagal!" onConfirm={() => this.setState({ alertSubmit: null })} onCancel={() => this.setState({ alertSubmit: null })}>
                {errorMessage}
            </SweetAlert>
        );
        this.setState({
            alertSubmit: alertFailure(),
        });
    }

    getAccess() {
        axiosInstance
            .post("/access/get", {
                case_id: this.props.currentCase.case_id,
                api_student_id: this.props.idStudent,
                student_name: this.props.studentName,
                schedule_id: this.props.caseStudent.schedules.id,
                school_id: this.props.currentCase.school_id,
            })
            .then((r) => {
                const lockedFromServer = r.data.is_locked == 1 || r.data.is_locked === true || r.data.is_locked === '1';
                this.setState({ isLocked: lockedFromServer ? true : this.state.isLocked });
            })
            .catch((error) => {
                // not found
                console.error(`ERROR from Server => ${error.message}`);
            });
    }

    unlockAccess(password) {
        axiosInstance
            .post("/access/unlock", {
                case_id: this.props.currentCase.case_id,
                api_student_id: this.props.idStudent,
                student_name: this.props.studentName,
                schedule_id: this.props.caseStudent.schedules.id,
                school_id: this.props.currentCase.school_id,
                password: password,
            })
            .then((r) => {
                this.setState({ isLocked: false });
                // NEW: Reset counter after successful unlock
                this.setState({ countNotFocus: 0 });
                localStorage.setItem("counterNotFocus", "0");
            })
            .catch((error) => {
                // not found
                console.error(`ERROR from Server => ${error.message}`);
            });
    }

    handleSquareClick(id) {
        const element = document.getElementById(`question-${id}`);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth", // Smooth scrolling
                block: "center", // Scroll to the top of the element
            });
        }
    }

    componentWillUnmount() {
        // NEW: Clean up event listeners
        window.removeEventListener("blur", this.handleBlur);
        window.removeEventListener("focus", this.handleFocus);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);

        // AUTO-SAVE: Clean up interval and beforeunload
        if (this.autoSaveInterval) {
            clearInterval(this.autoSaveInterval);
            this.autoSaveInterval = null;
        }
        window.removeEventListener("beforeunload", this.handleBeforeUnload);

        if (this.state.submitCases === true) {
            localStorage.removeItem("reduxState");
            localStorage.removeItem("dataSoal");
            this.props.deleteCaseActive();
        }
    }

    deepEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        return arr1.every((obj, index) => {
            const obj2 = arr2[index];
            return Object.keys(obj).every((key) => obj[key] === obj2[key]);
        });
    }

    componentDidUpdate(prevProps) {
        const currentAnsweredCase = this.props.getStudentAnsweredCase();
        const prevAnsweredCase = prevProps.getStudentAnsweredCase();

        if (currentAnsweredCase && !this.deepEqual(this.state.questions.filter((i) => i.answered).map((i) => i.id), prevAnsweredCase)) {
            const updatedQuestions = this.state.questions.map((question) => {
                if (currentAnsweredCase.includes(question.id)) {
                    return { ...question, answered: true };
                }
                return question;
            });

            // Check if state update is necessary
            const hasChanges = !this.deepEqual(
                this.state.questions,
                updatedQuestions
            );

            if (hasChanges) {
                this.setState({ questions: updatedQuestions });
            }
        }
    }

    // OLD -- DELETE
    // componentWillUpdate(prevProps, prevState) {
    //     if (!this.state.isFocus && !this.state.isLocked) {
    //         axiosInstance
    //             .post("/access/set", {
    //                 case_id: prevProps.currentCase.case_id,
    //                 api_student_id: prevProps.idStudent,
    //                 student_name: prevProps.studentName,
    //                 schedule_id: this.props.caseStudent.schedules.id,
    //                 is_generate: true,
    //                 school_id: prevProps.currentCase.school_id,
    //                 is_locked: true,
    //             })
    //             .then((r) => {
    //                 this.setState({isLocked: true}, playAudio);
    //             })
    //             .catch((error) => {
    //                 console.error(`ERROR from Server => ${error.message}`);
    //             });
    //     }
    // }

    handleNextQuestion = () => {
        if (this.state.activeQuestionIndex < this.state.flatQuestions.length - 1) {
            this.setState({ activeQuestionIndex: this.state.activeQuestionIndex + 1 });
        }
    };

    mappingFlatQuestions(props) {
        let flatQ = [];
        let qIndex = 0;

        if (props.caseStudent && props.caseStudent.case_parts) {
            Object.values(props.caseStudent.case_parts).forEach((part, partIndex) => {
                Object.values(part.case_questions).forEach((question) => {
                    flatQ.push({
                        ...question,
                        partName: part.name,
                        typeSoal: part.type_name,
                        partIndex: partIndex,
                        realIndex: qIndex
                    });
                    qIndex++;
                });
            });
        }
        return flatQ;
    }

    handlePrevQuestion = () => {
        if (this.state.activeQuestionIndex > 0) {
            this.setState({ activeQuestionIndex: this.state.activeQuestionIndex - 1 });
        }
    };

    handleSquareClick(id) {
        this.setState({ activeQuestionIndex: id - 1 });
    }

    render() {
        if (this.state.taskDone === true) {
            return <Redirect to="/" />;
        }

        if (this.state.isLocked) {
            return (
                <>
                    <SweetAlert
                        custom
                        showCloseButton={false}
                        closeOnClickOutside={false}
                        title="Akses dikunci!"
                        onConfirm={() => {
                            if (this.state.passwordValue.trim()) {
                                this.unlockAccess(this.state.passwordValue);
                                this.setState({ passwordValue: '', showPassword: false });
                            } else {
                                alert('Masukkan password terlebih dahulu!');
                            }
                        }}
                        confirmBtnText="Unlock"
                        confirmBtnBsStyle="primary"
                    >
                        <div style={{ marginTop: '20px', position: 'relative' }}>
                            <input
                                id="password-input"
                                type={this.state.showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Masukkan PASSWORD"
                                style={{
                                    fontSize: '18px',
                                    paddingRight: '45px',
                                    padding: '12px 45px 12px 15px',
                                }}
                                value={this.state.passwordValue}
                                onChange={(e) => this.setState({ passwordValue: e.target.value })}
                                autoFocus
                            />
                            <i
                                className={this.state.showPassword ? "mdi mdi-eye-off" : "mdi mdi-eye"}
                                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                style={{
                                    position: 'absolute',
                                    right: '15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    fontSize: '20px',
                                    color: '#666',
                                }}
                            />
                        </div>
                    </SweetAlert>
                </>
            );
        }

        const activeQ = this.state.flatQuestions[this.state.activeQuestionIndex];
        const totalQ = this.state.flatQuestions.length;
        const isFirstQuestion = this.state.activeQuestionIndex === 0;
        const isLastQuestion = this.state.activeQuestionIndex === totalQ - 1;

        return (
            <Fragment>
                <style jsx>{`
                    /* Mini Map Container for Sticky Behavior */
                    .mini-map-container {
                        position: sticky;
                        top: 10px;
                        z-index: 10;
                        background: #fff;
                        padding: 20px;
                        border-radius: 6px;
                        margin-bottom: 20px;
                        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
                    }

                    .mini-map {
                        position: sticky;
                        top: 10px;
                        display: flex;
                        flex-wrap: wrap;
                        gap: 5px;
                        padding: 5px;
                        margin-bottom: 10px;
                    }

                    /* Square Styling */
                    .square {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 40px;
                        width: 40px;
                        font-weight: bold;
                        cursor: pointer;
                        border-radius: 4px;
                        transition: all 0.3s ease;
                        margin: 5px 0;
                    }

                    .square.answered {
                        background-color: #21ba45;
                        color: white;
                    }

                    .square.unanswered {
                        background-color: #d3d3d3;
                        color: black;
                    }

                    .square:hover {
                        transform: scale(1.05);
                        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
                    }

                    .focus-warning {
                        position: fixed;
                        top: 20px;
                        left: 50%;
                        transform: translateX(-50%);
                        background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
                        color: white;
                        padding: 15px 30px;
                        border-radius: 8px;
                        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
                        z-index: 9999;
                        font-weight: bold;
                        animation: slideDown 0.3s ease-out;
                    }

                    @keyframes slideDown {
                        from {
                            transform: translateX(-50%) translateY(-100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateX(-50%) translateY(0);
                            opacity: 1;
                        }
                    }

                    .violation-indicator {
                        display: inline-block;
                        margin-bottom: 10px;
                        padding: 5px 10px;
                        background: rgba(255, 107, 107, 0.2);
                        border-radius: 4px;
                        font-size: 0.9em;
                    }
                `}</style>

                <Prompt
                    message={JSON.stringify({
                        confirmText: "Ya",
                        messageText: "Apakah kamu yakin keluar?",
                        cancelText: "Batal",
                    })}
                />

                <div className="main-panel">
                    <div className="content-wrapper" style={{ marginTop: '2rem' }}>
                        {/* NEW: Focus warning banner */}
                        {this.state.showFocusWarning && (
                            <div className="focus-warning">
                                ⚠️ PERINGATAN: Anda telah keluar dari halaman ujian {this.state.countNotFocus} kali.
                                Satu pelanggaran lagi akan mengunci ujian Anda!
                            </div>
                        )}

                        {/* NEW: Show violation count indicator */}
                        {this.state.countNotFocus > 0 && (
                            <span className="violation-indicator">
                                ⚠️ Pelanggaran: {this.state.countNotFocus}/3
                            </span>
                        )}

                        {this.props.caseStudent.case_parts === undefined ? (
                            <div className="d-flex justify-content-center">
                                <img src={Ball} className="img-fluid" alt="Loading..." />
                            </div>
                        ) : (
                            <div>
                                {/* PAGE HEADER */}
                                <div className="page-header">
                                    <div className="page-title d-flex">
                                        <span className="page-title-icon bg-gradient-primary text-white mr-2">
                                            <i className="mdi mdi-lead-pencil"></i>
                                        </span>
                                        <h1 style={{ marginRight: "20px" }}>{this.props.caseStudent.name}</h1>
                                        <label className="badge badge-gradient-danger align-self-center">{this.props.currentCase.course_name}</label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 grid-margin">
                                        <div className="alert alert-warning" role="alert">
                                            Jika ada yang salah pada data soal, silakan refresh halaman ini!
                                        </div>

                                        {/* --- MINI MAP --- */}
                                        <div className="mini-map-container">
                                            <h4>
                                                Pertanyaan Yang Sudah Di Jawab
                                                <button className="ui mini button" onClick={() => this.setState({ isMinimized: !this.state.isMinimized })} style={{ marginLeft: "10px" }}>
                                                    {this.state.isMinimized ? "Expand" : "Minimize"}
                                                </button>
                                            </h4>
                                            {!this.state.isMinimized && (
                                                <div className="mini-map">
                                                    {this.state.questions.map((question) => (
                                                        <div
                                                            key={question.id}
                                                            // Tambahkan class 'active' jika mau styling nomor yg sedang dibuka
                                                            className={`square ${question.answered ? "answered" : "unanswered"}`}
                                                            style={{
                                                                border: (question.id - 1) === this.state.activeQuestionIndex ? '2px solid blue' : 'none'
                                                            }}
                                                            onClick={() => this.handleSquareClick(question.id)}
                                                        >
                                                            {question.id}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        {/* --- KARTU SOAL (SINGLE QUESTION) --- */}
                                        <div className="card custom-card-shadow">
                                            <div className="card-body">

                                                {/* Header Bagian & Tipe Soal */}
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <div>
                                                        <h3 className="font-weight-bolder section-title d-inline">
                                                            {activeQ.partName}
                                                        </h3>
                                                        <span className="badge badge-info ml-3">
                                                            Soal No. {this.state.activeQuestionIndex + 1}
                                                        </span>
                                                    </div>
                                                    <h6 className="text-muted font-italic">{activeQ.typeSoal}</h6>
                                                </div>

                                                <hr />

                                                {/* RENDER KOMPONEN QUESTION */}
                                                {/* Key='activeQ.id' memaksa React me-render ulang saat ganti soal */}
                                                <div style={{ minHeight: '200px' }}>
                                                    <Question
                                                        key={activeQ.id}
                                                        typeSoal={activeQ.typeSoal}
                                                        itemQuestion={activeQ}
                                                        indexQuestion={activeQ.realIndex}
                                                        casePartId={activeQ.case_part_id}
                                                        indexPart={activeQ.partIndex}
                                                    />
                                                </div>

                                                <div className="dropdown-divider mt-5 mb-5 "></div>

                                                <div className="text-center">
                                                    {/* <button disabled={this.props.isRemedial} type="submit" className="btn btn-gradient-primary mr-2 " onClick={(e) => this.handleSave(e, this.props.timer.status)}>
                                                        Simpan Sementara
                                                    </button> */}
                                                    <button type="submit" className="btn btn-gradient-danger mr-2 " onClick={(e) => this.handleSubmit(e)}>
                                                        Serahkan Jawaban
                                                    </button>
                                                    {this.state.alertSave}
                                                    {this.state.alertSubmit === "submit" && !this.state.submitCases ? (
                                                        <SweetAlert
                                                            custom
                                                            showCancel
                                                            disabled={this.state.countDown !== 0}
                                                            showCloseButton
                                                            confirmBtnText="Ya"
                                                            cancelBtnText="Tidak"
                                                            confirmBtnBsStyle="primary"
                                                            cancelBtnBsStyle="light"
                                                            title="Serahkan Jawaban Kamu?"
                                                            onConfirm={() => this.submitExam(this.props.idStudent)}
                                                            onCancel={() => this.setState({ alertSubmit: null, countDown: this.state.initCountDown })}
                                                            afterMount={() => {
                                                                let currCountDown = this.state.countDown;
                                                                var countDownInterval = setInterval(() => {
                                                                    this.setState({ countDown: currCountDown-- });
                                                                    if (this.state.countDown === 0 || this.state.alertSubmit !== "submit") {
                                                                        clearInterval(countDownInterval);
                                                                    }
                                                                }, 1000);
                                                            }}
                                                        >
                                                            <div style={{ marginTop: "1rem", marginBottom: "1rem", lineHeight: "1.5" }}>Dengan Menyerahkan Jawaban, Maka Kamu Tidak Bisa Mengerjakan Kembali</div>
                                                            {this.state.countDown !== 0 ? <p style={{ color: "red", marginTop: "2rem", fontSize: "1", fontWeight: "400", lineHeight: "1.5" }}>Tombol akan aktif dalam {this.state.countDown} detik</p> : ""}
                                                        </SweetAlert>
                                                    ) : (
                                                        this.state.alertSubmit
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <Footer />
                </div >
            </Fragment >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        caseStudent: state.User.caseStudent,
        timer: state.User.timer,
        currentCase: state.User.currentCase,
        idStudent: state.User.dataStudent.student.api_student_id,
        listImgAll: state.User.caseStudent.listImg,
        isRemedial: state.User.currentCase.is_remedial,
        studentName: state.User.dataStudent.student.name,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadCaseSuccess: (list) => dispatch(loadCaseSuccess(list)),
        deleteCaseActive: () => dispatch(deleteCaseActive()),
        submitAnswer: () => dispatch(submitAnswer()),
        saveAnswer: () => dispatch(saveAnswer()),
        getStudentAnsweredCase: () => dispatch(getStudentAnsweredCase()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FormQuestion));
